import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { openErrorToast } from '../../../../reducers/uiLogic';
import PaymentKit from './PaymentKit';
import {
  SET_CHECKOUT_STATUS,
  paymentStateCheckoutFailure,
  paymentStateMarkOrderCreated,
  paymentsStateValidationStatusChange,
} from '../../../../actions/payments';
import { currentFlowTypeEnum } from '../../../common/components/constants';

const mapStateToProps = (state, { paymentSdkData }) => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const grandTotal = _get(paymentSdkData, 'amount', 10);
  const onlinePaymentsFlag = _get(paymentSdkData, 'online_payments_flag', 1);
  const userEmail = _get(paymentSdkData, 'user_details.user_email', '');
  const userPhone = _get(paymentSdkData, 'user_details.phone', '0');
  const countryId = _get(paymentSdkData, 'country_id', 1);
  const phoneCountryCode = _get(paymentSdkData, 'phone_country_code', '91');
  const serviceType = _get(paymentSdkData, 'service_type', '');
  const companyId = _get(paymentSdkData, 'company_id', '1');
  const isMobile = false;
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  const invoiceDetails = _get(state, 'company.invoiceDetails', {});
  return {
    currentFlow,
    selectedWorkspace,
    isMobile,
    grandTotal,
    onlinePaymentsFlag,
    countryId,
    phoneCountryCode,
    userEmail,
    userPhone,
    serviceType,
    companyId,
    invoiceDetails,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCheckoutState: (checkoutStatus, errorState) =>
      dispatch({ type: SET_CHECKOUT_STATUS, checkoutStatus, errorState }),
    paymentStateValidationStateChangeHandler: p =>
      dispatch(paymentsStateValidationStatusChange(p)),
    paymentStateMarkOrderCreated: p =>
      dispatch(paymentStateMarkOrderCreated(p)),
    paymentStateCheckoutFailed: p => dispatch(paymentStateCheckoutFailure(p)),
    showErrorToast: text => dispatch(openErrorToast(text)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentKit);
